export default (props) => {
  const { url, params, signal, headers } = props;
  // const fetchURL =
  //   url + (!url.indexOf("?") > 0 ? "&" : "?") + queryString.stringify(params);

  const searchPromise = fetch(url, {method:"POST", signal, headers,body:JSON.stringify(params) }).then((response) =>
    response.json(),
  );

  return Promise.all([searchPromise])
    .then((values) => {
      const [searchResponse] = values;
      const data = searchResponse;
      return data;
    })
    .catch((err) => {
      if (err.name === "AbortError") {
        return; // Continuation logic has already been skipped, so return normally
      }
      console.error(err);
    });
};
